"use client";
import React from "react";
import Link from "@/components/Link";
import { Box } from "@dxp-feed/ui/Box";
import { Text } from "@dxp-feed/ui/Text";
import bannerData from "@/utils/bannerData";
import EmblaSlider from "@/components/EmblaSlider";
import { addDataLayer } from "@/helpers/dataLayer";
import "@/styles/emblaCategorySlider.css";
import ImageWrapper from "@/components/ImageWrapper";
import {useRouter} from "next/navigation";

interface Category {
  label: string;
  description: string | null;
  link: string | null;
  linkTitle: string | null;
  fragmentPath: string | null;
  image: string;
  imagealt: string | null;
  target: string | null;
  ariaLabel: string | null;
}
interface PropsInterface {
  productcategories?: Category[];
}
export default function EmblaCategorySlider(props:Readonly<PropsInterface>) {
  const router = useRouter();
  const productCatLength = props?.productcategories?.length;

  return (
    <Box as="div" className="categorySliderEmbla">
     
      <EmblaSlider
        align="center"
        options={{ loop: true, align: "start", dragFree: true }}
        slidesPerView={{ base: 3, sm: 4, md: 7, lg: 7, xl: 8, xxl: 8 }}
        slidesToScroll={{ base: 3, sm: 4, md: 7, lg: 7, xl: 2, xxl: 2 }}
        showControls={true}
        thumbnails={false}
        className="embla_CategorySlider"
      > 
        {props?.productcategories?.map((cateData: any, index: number) => (
          <Box
            as="div"
            className="mb-[8px] lg:mb-[10px] mt-[4px]"
            key={cateData.label + index}
            >
            <Box 
              onClick={() => {
                router.push(`${cateData.link ?? ""}`);
                addDataLayer({
                  event: "category_cta",
                  click_text: `${cateData.label}`,
                  click_url: `${index + 1}`,
                  page_title: document.title,
                });
              }}
              className="flex flex-col items-center justify-center gap-[8px] cursor-pointer"
              tabIndex={0}
            >
             <ImageWrapper
                src={`${process.env.NEXT_PUBLIC_AEM_PATH_URL?.replace(/\/$/, "")}/${cateData.image?.replace(/^\//, "")}`}
                width={96}
                height={96}
                className="mobImageCat"
                alt={cateData.imagealt || cateData.label || 'Category image'}
              />
              <Text
                as="p"
                className="text-grey950 3xs:text-base text-sm font-semibold max-w-[120px] w-full mx-auto text-center"
              >
                {cateData.label}
              </Text>
            </Box>
          </Box>
        ))}
      </EmblaSlider>
    </Box>
  );
}
